import PropTypes from 'prop-types';
import React, { useState, useEffect , useRef } from 'react';
import { Box, Button, InputAdornment, TextField, Typography, styled } from '@mui/material';
import { useSnackbar } from 'notistack';

import MyDialog from '../../../../components/dialog-component/my-dialog';
import Iconify from '../../../../components/Iconify';
import { dispatch } from '../../../../redux/store';
import { openModal } from '../../../../redux/slices/authUiSlice';
import useAuth from '../../../../hooks/useAuth';
import useLocales from '../../../../hooks/useLocales';

const StyledTextField = styled(TextField)({
  marginBottom: '16px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',

    '& fieldset': {
      borderColor: '#e0e0e0',
      borderWidth: '2px',
    },

    '&:hover fieldset': {
      borderColor: '#e0e0e0',
    },

    '&.Mui-focused fieldset': {
      borderColor: '#f0a500',
      borderWidth: '2px',
    },

    '& input': {
      color: '#000', // 👈 FIX: set text color
    },

    '& input::placeholder': {
      color: '#bbb',
      opacity: 1,
    },
  },
});

const GradientButton = styled(Button)(() => ({
  padding: '12px',
  borderRadius: '8px',
  textTransform: 'none',
  fontWeight: 600,
  background: 'linear-gradient(180deg, #f5d08a, #e0a95c)',
  color: '#333',

  '&:hover': {
    background: 'linear-gradient(180deg, #eac47a, #d89b4e)',
  },

  '&.Mui-disabled': {
    opacity: 0.6,
    color: '#333',
    background: 'linear-gradient(180deg, #f5d08a, #e0a95c)',
  },
}));

const InputField = ({ icon, type, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === 'password';

  let inputType = type;

  if (isPassword) {
    inputType = showPassword ? 'text' : 'password';
  }

  return (
    <StyledTextField
      fullWidth
      {...props}
      type={inputType}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Iconify icon={icon} width={24} height={24} color="#bbb" />
          </InputAdornment>
        ),
        endAdornment: isPassword && (
          <InputAdornment position="end">
            <Box sx={{ cursor: 'pointer', display: 'flex' }} onClick={() => setShowPassword((prev) => !prev)}>
              <Iconify
                icon={showPassword ? 'mdi:eye-outline' : 'mdi:eye-off-outline'}
                width={24}
                height={24}
                color="#bbb"
              />
            </Box>
          </InputAdornment>
        ),
      }}
    />
  );
};

InputField.propTypes = {
  icon: PropTypes.any,
  type: PropTypes.any,
};

const _loginForm = {
  userUsername: '',
  userPassword: '',
  // captcha: '',
};

const LoginForm = ({ handleClose, handleOpen }) => {
  const { login } = useAuth();


  const { enqueueSnackbar } = useSnackbar();

  const { translate } = useLocales();






  const [loginForm, setLoginForm] = useState(_loginForm);

  const [, setIsLoading] = useState(false);

  const onSubmitRef = useRef(null);

  const [, setFormError] = useState({});

  useEffect(() => {
    onSubmitRef.current = onSubmit;
  });

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === 'Enter') {
        onSubmitRef.current();
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, []);

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setLoginForm((prevState) => ({ ...prevState, [name]: value }));
  };

  const onSubmit = async (event) => {
    event?.preventDefault();

    if (!isValid()) return;

    setIsLoading(true);

    const requestData = {
      // 'user-username': 'testmymember1',
      'user-username': loginForm?.userUsername?.trim(),
      'user-password': loginForm?.userPassword.trim(),
    };

    try {
      await login(requestData);
      window.parent.location = '/';
      // close login/register dialog
    } catch (err) {
      console.log(`Error: ${err.message}`);
      const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
      enqueueSnackbar(err.message, snackbarOptions);
    } finally {
      setIsLoading(false);
    }
  };

  const isValid = () => {
    let valid = true;
    const _error = {};

    if (!loginForm?.userUsername?.trim()) {
      valid = false;
      _error.userUsername = translate('invalid_x', { x: translate('username') });
    } else if (loginForm?.userUsername?.trim().length < 3) {
      valid = false;
      _error.userUsername = translate('invalid_x_must_be_atleast_y_characters', { x: translate('username'), y: '3' });
    } else {
      _error.userUsername = '';
    }

    if (loginForm?.userPassword?.trim()?.length < 6 || loginForm?.userPassword?.trim()?.length > 20) {
      valid = false;
      _error.userPassword = translate('password_must_be_6_to_20');
    } else {
      _error.userPassword = '';
    }

    setFormError(() => _error);

    return valid;
  };

  return (
    <MyDialog open={handleOpen} close={handleClose} maxSize={'sm'} title={translate('login')}>
      {/* Segmented Control */}
      {/* <SegmentContainer sx={{ mb: 4 }}>
        {tabs.map((item, i) => (
          <SegmentButton
            key={i}
            active={tab === i ? 1 : 0}
            onClick={() => setTab(i)}
            sx={{
              borderRadius: '999px',
            }}
          >
            <Iconify icon={item.icon} width={18} />
            {item.label}
          </SegmentButton>
        ))}
      </SegmentContainer> */}

      {/* {tab === 0 && ( */}
      <InputField
        placeholder={translate('username')}
        icon="mdi:account-outline"
        name="userUsername"
        value={loginForm?.userUsername}
        onChange={(e) => handleFormChange(e)}
      />
      {/* )} */}

      {/* {tab === 1 && (
      <Box sx={{ display: 'flex', gap: 1 }}>
        <TextField
          select
          value={countryCode}
          onChange={(e) => setCountryCode(e.target.value)}
          sx={{
            width: 130,
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
              backgroundColor: '#f5f5f5',
              color: '#000000',
            },
          }}
          SelectProps={{
            renderValue: (selected) => {
              const country = countries.find((c) => c.code === selected);
              return (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <img src={country?.flag} alt="" style={{ width: 22, height: 16, borderRadius: 3 }} />
                  {selected}
                </Box>
              );
            },
            MenuProps: {
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              PaperProps: {
                sx: {
                  borderRadius: '10px',
                  minWidth: 200,
                  backgroundColor: '#fff',
                  color: '#000',

                  '& .MuiMenu-list': {
                    paddingTop: 0,
                    paddingBottom: 0,
                  },
                },
              },
            },
          }}
        >
          {countries.map((c) => (
            <MenuItem
              key={c.code}
              value={c.code}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                py: 0.5,
                minHeight: 'unset',
                height: 36,

                '&.Mui-selected': {
                  background: 'linear-gradient(90deg, #f7c873, #e6a23c)',
                  color: '#000000',
                },

                '&.Mui-selected:hover': {
                  background: 'linear-gradient(90deg, #f7c873, #e6a23c)',
                },

                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              <img
                src={c.flag}
                alt=""
                style={{
                  width: 24,
                  height: 16,
                  borderRadius: 3,
                  objectFit: 'cover',
                }}
              />

              <Typography fontSize={14}>{c.label}</Typography>

              <Typography fontSize={14} sx={{ marginLeft: 'auto', color: '#333' }}>
                {c.code}
              </Typography>
            </MenuItem>
          ))}
        </TextField>

        <InputField fullWidth placeholder="0XXXXXXXXX" value={phone} onChange={(e) => setPhone(e.target.value)} />
      </Box>
       )} */}

      <InputField
        placeholder={translate('password')}
        type="password"
        icon="mdi:lock-outline"
        endIcon="mdi:eye-off-outline"
        name="userPassword"
        value={loginForm?.userPassword}
        onChange={(e) => handleFormChange(e)}
      />

      <Box sx={{ textAlign: 'right', mb: 2 }}>
        <Typography
          onClick={() => {
            dispatch(
              openModal({
                view: 'forgot',
              })
            );
          }}
          variant="body2"
          sx={{ color: '#666', cursor: 'pointer' }}
        >
          {translate('forgot_password')}?
        </Typography>
      </Box>

      <GradientButton
        fullWidth
        disabled={!loginForm?.userUsername && !loginForm.userPassword}
        onClick={() => onSubmit()}
      >
        {translate('login')}
      </GradientButton>

      {/* Footer */}
      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <Typography variant="body2" sx={{ color: '#666', fontWeight: 600 }}>
          {translate('dont_have_account')}
          <Box
            component="span"
            sx={{ color: '#4caf50', cursor: 'pointer' }}
            onClick={() => {
              dispatch(
                openModal({
                  view: 'register',
                })
              );
            }}
          >
            {` ${translate('create_an_account')}`}
          </Box>
        </Typography>
      </Box>
    </MyDialog>
  );
};

LoginForm.propTypes = {
  handleClose: PropTypes.func,
  handleOpen: PropTypes.func,
};

export default LoginForm;
